"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../");
var React = require("react");
var Components_1 = require("../../Components");
var Services_1 = require("../../Services");
function OfflineTemplateUploadEvent(fileEvent, resources, location) {
    var eventContentRef = React.createRef();
    //console.log("OfflineTemplateUploadEvent");
    return new __1.VeriLiteWarningEvent(React.createElement(OfflineTemplateUploadEventContent, { ref: eventContentRef, fileEvent: fileEvent, resources: resources, location: location }), resources.SetupLocations_Loading, []);
}
exports.OfflineTemplateUploadEvent = OfflineTemplateUploadEvent;
var OfflineTemplateUploadEventContentState;
(function (OfflineTemplateUploadEventContentState) {
    OfflineTemplateUploadEventContentState[OfflineTemplateUploadEventContentState["Initial"] = 0] = "Initial";
    OfflineTemplateUploadEventContentState[OfflineTemplateUploadEventContentState["Pending"] = 1] = "Pending";
    OfflineTemplateUploadEventContentState[OfflineTemplateUploadEventContentState["Success"] = 2] = "Success";
    OfflineTemplateUploadEventContentState[OfflineTemplateUploadEventContentState["Error"] = 3] = "Error";
})(OfflineTemplateUploadEventContentState || (OfflineTemplateUploadEventContentState = {}));
var OfflineTemplateUploadEventContent = /** @class */ (function (_super) {
    __extends(OfflineTemplateUploadEventContent, _super);
    function OfflineTemplateUploadEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.error = {};
        //console.log("OfflineTemplateUploadEventContent Constructor");
        _this.state = {
            status: OfflineTemplateUploadEventContentState.Pending
        };
        return _this;
    }
    OfflineTemplateUploadEventContent.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //console.log("OfflineTemplateUploadEventContent componentDidMount");
                Services_1.OfflineTemplateService.upload(this.props.fileEvent, this.props.resources, this.props.location)
                    .then(function (response) {
                    var eventHandler = Services_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Upload_Complete;
                    event.actions = [
                        new __1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    _this.setState({ status: OfflineTemplateUploadEventContentState.Success });
                })
                    .catch(function (err) {
                    if (err.cancel) {
                        var eventHandler = Services_1.EventHandlerProvider.GetInstance();
                        eventHandler.HandleEvent();
                        return;
                    }
                    var eventHandler = Services_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Error_Generic;
                    _this.error.detail = err;
                    event.actions = [
                        new __1.VeriLiteEventAction(_this.props.resources.Ok, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    _this.setState({ status: OfflineTemplateUploadEventContentState.Error });
                });
                return [2 /*return*/];
            });
        });
    };
    OfflineTemplateUploadEventContent.prototype.render = function () {
        switch (this.state.status) {
            case OfflineTemplateUploadEventContentState.Pending:
                return React.createElement(Components_1.CustomSpinner, null);
            case OfflineTemplateUploadEventContentState.Success:
                return this.props.resources.Upload_ToDeferredLog;
            case OfflineTemplateUploadEventContentState.Error:
                return this.error.detail;
        }
        return "unknown state";
    };
    return OfflineTemplateUploadEventContent;
}(React.Component));
//# sourceMappingURL=OfflineTemplateUploadEvent.js.map